import { RootState } from '../../../applicationStore';
import { SkillsState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getSkillsState = (state: RootState): SkillsState => state.skills;

export const getSkillsLoader = createSelector(
  getSkillsState,
  (state): boolean => state.loading,
);

export const getSkillsData = createSelector(
  getSkillsState,
  (state): SkillsState['data'] | null => state?.data || [],
);
